const LS_CURRENCY_KEY = "CURRENCY";

export const getCurrency = (): string | null => {
  return localStorage.getItem(LS_CURRENCY_KEY);
};

export const setCurrency = (currency: string): void => {
  return localStorage.setItem(LS_CURRENCY_KEY, currency);
};
